<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    size="xl"
    scrollable
    no-close-on-backdrop
  >
    <b-row class="modal-vacaciones">
      <b-col cols="12">
        <b-card
          style="margin-bottom: 1rem !important"
          :body-class="[
            'vacaciones-info mb-0 p-1',
            isDarkSkin ? 'custom-dark' : 'custom-light',
          ]"
        >
          <b-row class="align-items-center">
            <b-col cols="2" class="info-item">
              <span class="label">Regimen Laboral:</span>
              <b-badge variant="light-primary">{{
                empleado.regimen_laboral
              }}</b-badge>
            </b-col>

            <b-col cols="2" class="info-item">
              <span class="label">Sueldo:</span>
              <b-badge variant="light-info">{{ empleado.sueldo }}</b-badge>
            </b-col>

            <b-col cols="2" class="info-item">
              <span class="label">Sueldo diario:</span>
              <b-badge variant="light-success">{{
                empleado.sueldo_diario
              }}</b-badge>
            </b-col>

            <b-col cols="2" class="info-item">
              <span class="label">Valor de compra (S/.):</span>
              <b-badge variant="light-warning">{{
                totalCostoVacaciones
              }}</b-badge>
            </b-col>

            <b-col cols="2" class="info-item">
              <span
                v-b-tooltip.hover="
                  'Vacaciones disponibles del primer periodo con vacaciones disponibles'
                "
                class="label"
                >Dias restantes:</span
              >
              <b-badge variant="light-warning">{{
                vacacionesRestantesPeriodo
              }}</b-badge>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12" class="mb-1">
        <div class="periodo-info mb-0 overflow-scroll-x">
          <div class="d-flex flex-nowrap">
            <b-col
              cols="3"
              v-for="(item, index) in periodos"
              :key="index"
              class="periodo-col mx-1 flex-shrink-0"
              :class="{
                activo:
                  index === firstPeriodoConVacacionesIndex &&
                  item.vacaciones_disponibles > 0,
                inactivo:
                  index !== firstPeriodoConVacacionesIndex ||
                  item.vacaciones_disponibles <= 0,
              }"
            >
              <div class="d-flex align-items-stretch h-100">
                <!-- Columna izquierda -->
                <div
                  class="periodo-label d-flex align-items-center justify-content-center px-2"
                >
                  PERIODO {{ item.periodo }}
                </div>

                <!-- Columna derecha -->
                <div
                  class="flex-grow-1 d-flex flex-column justify-content-between ps-3"
                >
                  <div class="indicador-top">
                    Vacaciones disponibles:
                    <strong>{{ item.vacaciones_disponibles }}</strong>
                  </div>
                  <div class="indicador-bottom">
                    Vacaciones por acumular:
                    <strong>{{ item.vacaciones_por_acumular }}</strong>
                  </div>
                  <div class="indicador-bottom">
                    Vacaciones tomadas:
                    <strong>{{ item.vacaciones_tomadas }}</strong>
                  </div>
                </div>
              </div>
            </b-col>
          </div>
        </div>
      </b-col>

      <b-col
        v-if="diasRestantesMasPorAcumular - maximasVacacionesRestantes > 0"
        cols="12"
      >
        <b-alert show variant="warning" class="p-1 d-flex align-items-start">
          <div class="d-flex align-items-center">
            <feather-icon icon="AlertTriangleIcon" class="mr-1" size="18" />
            <span>
              Actualmente tienes más de 15 días acumulados con proyección a fin
              del periodo ({{ diasRestantesMasPorAcumular }} dias), debes
              programar al menos
              {{ diasRestantesMasPorAcumular - maximasVacacionesRestantes }}
              días antes de fin del periodo.
            </span>
          </div>
        </b-alert>
      </b-col>

      <b-col cols="12">
        <b-card
          style="margin-bottom: 1rem !important"
          :body-class="isDarkSkin ? 'custom-dark' : 'custom-light'"
        >
          <b-card-title>
            <div class="d-flex justify-content-between">
              <span>Programación de Vacaciones</span>
              <div class="d-flex align-items-center">
                <div
                  class="rounded border"
                  style="width: 10px; height: 10px; background-color: #558fc3"
                ></div>
                <span class="mr-1" style="margin-left: 0.5rem"
                  >Por registrar</span
                >
                <div
                  class="rounded border"
                  style="width: 10px; height: 10px; background-color: #cd6e75"
                ></div>
                <span style="margin-left: 0.5rem">Programadas</span>
              </div>
            </div>
          </b-card-title>
          <b-row>
            <b-col cols="8">
              <div class="d-flex justify-content-start align-items-center">
                <vc-date-picker
                  v-model="fechaActual"
                  style="width: 100%; overflow: hidden"
                  :columns="4"
                  :rows="1"
                  :is-dark="isDarkSkin"
                  
                  :model-config="config"
                  mode="multiple"
                  :attributes="attributes"
                  @dayclick="onDayClick"
                />
                <!-- :min-date="minDate" -->
              </div>
            </b-col>
            <b-col cols="4">
              <div class="d-flex justify-content-start">
                <span
                  >Días seleccionados:
                  <span class="font-weight-bold">{{ diasSeleccionados }}</span>
                </span>
              </div>

              <b-table
                small
                sticky-header="63vh"
                responsive
                hover
                :items="form.fechas"
                :fields="vacaciones_por_programar_fields"
                show-empty
                empty-text="No hay fechas seleccionadas"
              >
                <template #cell(id)="data">
                  <span>{{ data.value | myGlobal }}</span>
                </template>
                <template #cell(comprar)="data">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox v-model="data.item.comprar" />
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col cols="12" class="mb-1">
              <div class="d-flex justify-content-end">
                <span
                  v-if="vacacionesRestantesPeriodo > maximasVacacionesRestantes"
                  class="text-danger"
                >
                  Debe programar al menos
                  {{ totalVacacionesDisponibles - maximasVacacionesRestantes }}
                  días de vacaciones.
                </span>
              </div>
            </b-col> -->
            <!-- || cantidadMinimaValida -->
            <b-col cols="12">
              <div class="d-flex justify-content-end">
                <b-button
                  variant="outline-primary"
                  class="float-right"
                  @click="store"
                  :disabled="diasSeleccionados === 0"
                >
                  PROGRAMAR
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- <b-col v-if="form.range && form.range.start && form.range.end" cols="12">
        <b-card :body-class="isDarkSkin ? 'custom-dark' : 'custom-light'">
          <b-card-title>Vacaciones Programadas</b-card-title>
          <b-card-text class="text-muted"
            >Listado de vacaciones programadas entre {{ form.range.start }} y
            {{ form.range.end }}</b-card-text
          >
          <b-row>
            <b-col md="12" lg="12" xl="12">
              <b-table
                small
                responsive
                hover
                :items="vacaciones_programadas"
                :fields="vacaciones_programadas_fields"
              >
                <template #cell(empleado)="data">
                  <span class="text-primary">{{ data.value }}</span>
                </template>
                <template #cell(fechas)="data">
                  <b-badge
                    v-for="(fecha, index) in data.item.fechas_vacaciones"
                    :key="index"
                    class="mr-1"
                    variant="light-primary"
                    >{{ fecha }}</b-badge
                  >
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col> -->
    </b-row>
  </b-modal>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VacacionesService from "@/views/rrhh/views/payroll/components/vacaciones/service/vacaciones.service.js";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import {
  vacaciones_programadas_fields,
  vacaciones_por_programar_fields,
} from "@/views/rrhh/views/payroll/components/vacaciones/data/vacaciones.programadas.fields.js";
export default {
  props: {
    idPersonal: {
      type: Number,
      require: true,
    },
  },
  components: {
    ToastificationContent,
  },
  data() {
    return {
      fechaActual: null,
      vacaciones_programadas_fields,
      vacaciones_por_programar_fields,
      config: {
        type: "string",
        timeZone: "America/Lima",
        mask: "YYYY-MM-DD",
      },
      showModal: true,
      empleado: {
        empleado: "",
      },
      periodos: [],
      form: {
        // range: null,
        fechas: [],
      },
      vacaciones_programadas: [],
      highlightedDates: [],
      days: [],
    };
  },
  computed: {
    totalVacacionesDisponibles() {
      return this.periodos.reduce((total, item) => {
        return total + (item.vacaciones_disponibles || 0);
      }, 0);
    },
    diasSeleccionados() {
      return this.days.length;
    },
    dates() {
      return this.days.map((day) => day.date);
    },
    minDate() {
      return new Date(new Date().setDate(new Date().getDate() + 1));
    },
    attributes() {
      const userSelectedDates = this.dates.map((date) => ({
        key: "seleccionadas",
        highlight: true,
        dates: date,
        contentStyle: {
          backgroundColor: "#007bff",
          color: "#fff",
          borderRadius: "50%",
        },
      }));

      const fechasProgramadas = this.highlightedDates.map((attr) => ({
        key: "programadas",
        highlight: {
          color: "red",
          fillMode: "solid",
        },
        dates: attr.dates,
        contentStyle: {
          backgroundColor: "#dc3545",
          color: "#fff",
          borderRadius: "50%",
        },
      }));

      return [...userSelectedDates, ...fechasProgramadas];
    },
    title() {
      return `PROGRAMAR VACACIONES: ${this.empleado.empleado}`;
    },

    totalCostoVacaciones() {
      let vacaciones_por_comprar = this.form.fechas.filter(
        (fecha) => fecha.comprar
      ).length;

      return this.empleado.sueldo_diario * vacaciones_por_comprar;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    // Excedente minimo de vacaciones a programar
    maximasVacacionesRestantes() {
      return this.empleado.vacaciones_por_anio;
    },

    firstPeriodoConVacacionesIndex() {
      return this.periodos.findIndex((item) => item.vacaciones_disponibles > 0);
    },

    /**
     * Dias restantes del primer periodo con vacaciones disponibles
     */
    vacacionesRestantesPeriodo() {
      const index = this.firstPeriodoConVacacionesIndex;

      if (index === -1 || !this.periodos[index]) {
        return 0;
      }

      return this.periodos[index].vacaciones_disponibles || 0;
    },

    cantidadMinimaValida() {
      return this.vacacionesRestantesPeriodo > this.maximasVacacionesRestantes;
    },

    vacacionesAProgramar() {
      return this.form.fechas.length;
    },

    diasRestantesMasPorAcumular() {
      // sumar todos los  vacaciones_por_acumular y vacaciones_disponibles
      return this.periodos.reduce((total, item) => {
        return (
          total +
          (item.vacaciones_por_acumular || 0) +
          (item.vacaciones_disponibles || 0)
        );
      }, 0);
    },
  },
  mounted() {
    this.index();
    this.show();
  },
  methods: {
    formateaFecha(fecha) {
      const date = new Date(fecha);
      const dia = date.getDate().toString().padStart(2, "0");
      const mes = (date.getMonth() + 1).toString().padStart(2, "0");
      const anio = date.getFullYear();
      return `${dia}/${mes}/${anio}`;
    },
    onDayClick(day) {
      // validar que solo pueda seleccionar hasta como maximo el total de restantes del periodo actual
      const dateClicked = new Date(day.id);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Si es fecha antigua
      // if (dateClicked <= today) {
      //   return;
      // }

      // Si ya se programo vacaciones para el colaborador ese dia
      const yaProgramada = this.highlightedDates.some((attr) => {
        const fechaProgramada = new Date(attr.dates);
        const fechaClickeada = new Date(day.id);

        const fechaProgramadaStr = fechaProgramada.toISOString().split("T")[0]; // "2025-06-30"
        const fechaClickeadaStr = fechaClickeada.toISOString().split("T")[0]; // "2025-06-30"

        return fechaProgramadaStr === fechaClickeadaStr;
      });

      if (yaProgramada) {
        return;
      }
      const idx = this.days.findIndex((d) => d.id === day.id);

      if (idx >= 0) {
        // Quitar de días seleccionados
        this.days.splice(idx, 1);

        // Quitar de fechas usando id, no solo fecha
        this.form.fechas = this.form.fechas.filter(
          (f) => f.fecha !== day.date && f.id !== day.id
        );

        this.fechaActual = null;
      } else {
        // Si ya no tiene dias restantes
        if (this.vacacionesRestantesPeriodo === this.form.fechas.length) {
          return;
        }

        this.days.push({
          id: day.id,
          date: day.date,
        });

        this.form.fechas.push({
          id: day.id,
          comprar: false,
        });
      }
    },

    async store() {
      const DIAS_MINIMOS_REQUERIDOS = 5;

      const diasAProgramar = this.vacacionesAProgramar;
      const diasDisponibles = this.vacacionesRestantesPeriodo;

      const estaProgramandoMenosDeMinimo =
        diasAProgramar < DIAS_MINIMOS_REQUERIDOS;
      const quedanMenosDeMinimo = diasDisponibles < DIAS_MINIMOS_REQUERIDOS;
      const estaProgramandoTodosLosRestantes =
        diasAProgramar === diasDisponibles;

      // 🔹 Caso 1: Programar menos de 5 días solo se permite si quedan menos de 5
      if (estaProgramandoMenosDeMinimo && !quedanMenosDeMinimo) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Atención",
            icon: "InfoIcon",
            variant: "warning",
            text: `Solo puede programar menos de ${DIAS_MINIMOS_REQUERIDOS} días si le quedan menos de ${DIAS_MINIMOS_REQUERIDOS} días disponibles en el periodo. Actualmente tiene ${diasDisponibles}.`,
          },
        });
        return;
      }

      // 🔹 Caso 2: Si le quedan más de 5 días, solo puede programar 5 o más, o todos los restantes
      const quedanMasDeMinimo = diasDisponibles > DIAS_MINIMOS_REQUERIDOS;
      const estaProgramandoMenosDeMinimoYNoTodos =
        estaProgramandoMenosDeMinimo && !estaProgramandoTodosLosRestantes;

      if (quedanMasDeMinimo && estaProgramandoMenosDeMinimoYNoTodos) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Atención",
            icon: "InfoIcon",
            variant: "warning",
            text: `Debe programar al menos ${DIAS_MINIMOS_REQUERIDOS} días o exactamente los ${diasDisponibles} que le quedan en el periodo.`,
          },
        });
        return;
      }

      try {
        const { isConfirmed } = await this.showConfirmSwal();
        if (!isConfirmed) {
          return;
        }
        this.addPreloader();
        const params = {
          id_personal: this.idPersonal,
          fechas: this.form.fechas,
          id_usuario: this.currentUser.id,
          costo_por_vacacion_comprada: this.empleado.sueldo_diario,
        };
        const { data } = await VacacionesService.programarVacaciones(params);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        this.$emit("store", data);
      } catch (error) {
        console.error(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XIcon",
            variant: "danger",
            text: "Error al programar las vacaciones.",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    // async getVacacionesProgramadasPorFecha() {
    //   try {
    //     this.addPreloader();
    //     const params = {
    //       from: this.form.range.start,
    //       to: this.form.range.end,
    //     };
    //     const { data } =
    //       await VacacionesService.getVacacionesProgramadasPorFecha(params);
    //     this.vacaciones_programadas = data || [];
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.removePreloader();
    //   }
    // },

    async index() {
      try {
        this.addPreloader();
        const { data } =
          await VacacionesService.getVacacionesProgramadasPorEmpleado({
            id_personal: this.idPersonal,
          });

        const programadas = data.map((vacacion) => ({
          dates: moment.tz(vacacion.fecha, "America/Lima").toDate(),
          // dot: true,
          highlight: "red",
        }));

        this.highlightedDates = programadas;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
    async show() {
      try {
        this.addPreloader();
        const { data } = await VacacionesService.getDataProgramarVacaciones({
          id: this.idPersonal,
        });
        this.empleado = data.empleado;
        this.periodos = data.periodos;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
.modal-vacaciones {
  .custom-dark {
    background-color: #111113 !important;
  }

  .custom-light {
    background-color: #f8f9fa !important;
  }

  .vacaciones-info {
    .info-item {
      display: flex;
      align-items: center;
      font-size: 1.3rem;

      .label {
        min-width: 140px;
        font-weight: 600;
        font-size: 1rem;
        margin-right: 0.5rem;
      }
    }
  }
  .overflow-scroll-x {
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 0.5rem;
  }
  .periodo-info {
    .periodo-col {
      padding: 0.5rem 2rem;
      border-radius: 10px;

      &.activo {
        background-color: #e9f5ff;
        border-left: 4px solid #0d6efd;
        font-weight: 600;
      }

      &.inactivo {
        color: #6c757d;
        background-color: #f8f9fa;
      }

      .periodo-label {
        font-weight: bold;
        font-size: 0.9rem;
        text-align: center;
        min-width: 80px;
        border-radius: 6px;
      }

      .indicador-top,
      .indicador-bottom {
        font-size: 0.85rem;
      }
    }
  }
}

.dark-layout {
  .modal-vacaciones {
    .periodo-info {
      .periodo-col {
        &.activo {
          background-color: #111113;
          border-left: 4px solid #0d6efd;
        }

        &.inactivo {
          color: #b0b0b0;
          background-color: #2f2f31;
        }

        .periodo-label {
          color: #ffffff;
        }
      }
    }
  }
}
</style>